import { useState, useEffect, useCallback } from 'react';
import { toast } from 'sonner';
import { sourcingAPI } from '../../lib/api';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Loader2, Check, X } from 'lucide-react';

export default function VariantsTab() {
  const [loading, setLoading] = useState(true);
  const [variants, setVariants] = useState([]);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await sourcingAPI.listVariants('', 'PENDING');
      setVariants(res.data.variants);
    } catch (e) {
      toast.error('Failed to load variants');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const decide = async (id, decision) => {
    try {
      await sourcingAPI.decideVariant(id, decision);
      toast.success(decision === 'SAME' ? 'Marked as Same' : 'Marked as Different');
      load();
    } catch (e) {
      toast.error('Failed to update variant');
    }
  };

  if (loading) return <div className="flex justify-center py-16" data-testid="variants-loading"><Loader2 className="animate-spin" /></div>;

  return (
    <Card className="rounded-sm" data-testid="sourcing-variants-tab">
      <CardContent className="p-0 divide-y divide-border">
        {variants.map((v) => (
          <div key={v.id} className="p-3 flex items-center justify-between gap-3 text-sm" data-testid={`variant-row-${v.id}`}>
            <p className="font-mono">{v.variant_text}</p>
            <div className="flex gap-2">
              <Button size="sm" variant="outline" onClick={() => decide(v.id, 'SAME')} data-testid={`variant-same-btn-${v.id}`}>
                <Check className="h-3.5 w-3.5 mr-1" /> Same
              </Button>
              <Button size="sm" variant="ghost" onClick={() => decide(v.id, 'DIFFERENT')} data-testid={`variant-different-btn-${v.id}`}>
                <X className="h-3.5 w-3.5 mr-1" /> Different
              </Button>
            </div>
          </div>
        ))}
        {variants.length === 0 && <div className="p-8 text-center text-sm text-muted-foreground">No pending variants to review.</div>}
      </CardContent>
    </Card>
  );
}
